<template>
    <el-dialog ref="productCostDetailDialog" :before-close="handleDialogClose" :close-on-click-modal="false" title="成本明细" :visible.sync="productCostDetailDialog" class="custom-form-dialog custom-height-dialog" width="520px">
        <div class="product_cost_detail_wrap" v-loading="loading">
            <div class="custom_title" >
                <span>产品成本</span>
            </div>
            <div class="field_item">
                总金额：{{stockCostDetail.total_price}}
            </div>

            <div class="custom_title" >
                <span>出库成本</span>
            </div>

            <div class="field_item">
                总金额：{{stockCostDetail.out_total_price}}
            </div>

            <el-table class="custom_table" :data="stockCostDetail.out" border  ref="multipleTable" row-key="id"  >
                <el-table-column label="产品名称" prop="name" show-overflow-tooltip min-width="155px"></el-table-column>
                <el-table-column label="数量" prop="total_num" align="right" show-overflow-tooltip min-width="155px"></el-table-column>
                <el-table-column label="成本总价" prop="total_cost" align="right"  show-overflow-tooltip min-width="155px"></el-table-column>
            </el-table>

            <div class="custom_title mt_16" >
                <span>售后成本</span>
            </div>

            <div class="field_item">
                总金额：{{stockCostDetail.in_total_price}}
            </div>

            <el-table class="custom_table" :data="stockCostDetail.in" border  ref="multipleTable" row-key="id"  >
                <el-table-column label="产品名称" prop="name" show-overflow-tooltip min-width="155px"></el-table-column>
                <el-table-column label="数量" prop="total_num" align="right" show-overflow-tooltip min-width="155px"></el-table-column>
                <el-table-column label="成本总价" prop="total_cost" align="right"  show-overflow-tooltip min-width="155px"></el-table-column>
            </el-table>

        </div>
    </el-dialog>
</template>
<script>
import {ProjectManageStockCostDetail} from "@/api/index.js"
export default {
    name: "product_cost_detail",
    components: {

    },
    props: {
        productCostDetailDialog: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },

    },
    data() {
        return {
            loading: false,
            stockCostDetail:{}
        }
    },
    created() {
        if(this.projectId){
            this.getProjectManageCostDetail()
        }
    },
    methods: {
        getProjectManageCostDetail(){
            let postData = {
                project_manage_id:this.projectId
            }
            this.loading = true
            ProjectManageStockCostDetail(postData).then(res => {
                if (res.code === 200) {
                    this.stockCostDetail = res.data
                }
                this.loading = false
            })
        },
        handleDialogClose() {
            this.$emit("update:productCostDetailDialog", false)
        },

    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/project_management.scss";
</style>
